/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-grid-reset{display:flex;align-items:center}ui-grid-reset .ui-grid-reset-divider{height:30px;margin-right:10px}ui-grid-reset .ui-grid-reset-button{padding-right:16px}ui-grid-reset .ui-grid-reset-button span{text-transform:none}"];
export { styles as styles };
